import { ProductView } from "shared/mappers/database/accounting/product/product";
import PillarSelectComponent, {
  PillarFormProfileSelectProps,
} from "shared/components/pillar-form/components/PillarSelectComponent";

export type PillarFormProductSelectProps<FormType> = Omit<
  PillarFormProfileSelectProps<ProductView, number, FormType>,
  "labelCallback" | "valueCallback"
>;

const PillarFormProductSelect = <FormType,>({
  name,
  testid,
  ...props
}: PillarFormProductSelectProps<FormType>) => {
  return (
    <PillarSelectComponent<ProductView, number, FormType>
      name={name}
      cacheKey={["products"]}
      testid={`${testid}-modal-form-product`}
      additionalClasses="mb-1.5"
      {...props}
      labelCallback={(product) => {
        return product.name!;
      }}
      valueCallback={(product) => {
        return product.productId;
      }}
    />
  );
};

export default PillarFormProductSelect;
